import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as categoriesActions from '../actions/delivery-time-categories.actions';
import { MwDeliveryTimeCategoriesApiService } from 'app/services/delivery-time-categories-api.service';
@Injectable()
export class DeliveryTimeCategoriesEffects {
  constructor(
    private actions$: Actions,
    private deliveryTimeCategoriesApiService: MwDeliveryTimeCategoriesApiService
  ) {}

  loadDeliveryTimeCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(categoriesActions.loadDeliveryTimeCategories),
      switchMap(({ loadOptions }) => {
        const options = loadOptions;
        return this.deliveryTimeCategoriesApiService.get(options).pipe(
          map((response) => {
            return categoriesActions.loadDeliveryTimeCategoriesSuccess({
              response,
            });
          }),
          catchError((error) =>
            of(categoriesActions.loadDeliveryTimeCategoriesFailed({ error }))
          )
        );
      })
    );
  });
}
